export enum PanelSize {
    Normal = 0,
    Narrow
}
